import React from 'react';
import { Form } from 'react-final-form';
import createDecorator from 'final-form-focus';
import { TextField } from 'mui-rff';
import Button from '@mui/material/Button';
import { validate } from 'utils/validate';
import { schema } from './schema';
import { Box } from '@mui/material';
import { format } from 'utils/form';

const PHONE_MASK = format('(99) 99999-9999');

const focusOnErrors = createDecorator();

function EnviarSMSForm({ onSubmit }: any) {
  return (
    <Form
      onSubmit={onSubmit}
      decorators={[focusOnErrors]}
      validate={validate(schema)}
      render={({ handleSubmit, submitting }: any) => (
        <form onSubmit={handleSubmit} noValidate>
          <TextField name="telefone"
            type="text"
            placeholder="(XX) 9XXXX-XXXX"
            label="Telefone"
            margin="normal"
            fullWidth
            variant="outlined"
            fieldProps={{ inputProps: { maxLength: 14 } }}
            {...PHONE_MASK}
          />

          <Box mt={3}>
            <Button
              disabled={submitting}
              fullWidth
              variant="contained"
              color="primary"
              type="submit"
            >
              Enviar
            </Button>
          </Box>
        </form>
      )}
    />
  );
}

export default EnviarSMSForm;
